import { type AuthState, useAuthContext } from "contexts/auth-context/AuthProvider"

export function useAuth(): AuthState {
  return useAuthContext()
}
